'use strict';

var ready = require('../util/ready');

module.exports = function (config, listener) {
    var callback = function callback(e) {
        clearTimeout(timer);
        listener(e.bridge);
    },
        timer = void 0;
    document.addEventListener(config.bridgeReadyEvent, callback, false);
    timer = setTimeout(function () {
        document.removeEventListener(config.bridgeReadyEvent, callback);
        listener(null);
    }, config.bridgeReadyTimeout);
};


//////////////////
// WEBPACK FOOTER
// ../src/env/hy.js
// module id = 7
// module chunks = 0 2 4